<template>
  <div>
    <ActionsDropdown
      :drawer-direction="drawerDirection"
      @action-selected="actionSelected"
    />
  </div>
</template>

<script setup>
import ActionsDropdown from './actions-dropdown.vue'
import { drawerDirections } from '@app/shared/vue/components/sf-dropdown/constants'
import {
  ARCHIVE_WORKFLOW_ACTION,
  CREATE_REMARK_ACTION,
  DOWNLOAD_AS_EXCEL_ACTION,
  LOCK_PERIOD_ACTION,
} from './constants'

defineProps({
  drawerDirection: {
    type: String,
    default: drawerDirections.right,
  },
})

const emit = defineEmits(['downloadAsExcel'])

const actionSelected = ({ action, payload }) => {
  if (action === CREATE_REMARK_ACTION) {
    window.modalCitizen.openModalPortal(
      'insights-actions-create-remark-modal',
      payload
    )
  }

  if (action === DOWNLOAD_AS_EXCEL_ACTION) {
    emit(DOWNLOAD_AS_EXCEL_ACTION)
  }

  if (action === ARCHIVE_WORKFLOW_ACTION) {
    window.modalCitizen.openModalPortal(
      'insights-actions-archive-workflow-modal',
      payload
    )
  }

  if (action === LOCK_PERIOD_ACTION) {
    window.modalCitizen.openModalPortal(
      'insights-actions-lock-period-modal',
      payload
    )
  }
}
</script>
